export default "__VITE_ASSET__DqEc0Pz6__"